export const CSV_DATA_SUCCESS="people/CSV_DATA_SUCCESS";
export const CSV_DATA_FAILURE="people/CSV_DATA_FAILURE";
export const REACTIVATE_USER_SUCCESS="people/REACTIVATE_USER_SUCCESS";
export const REACTIVATE_USER_FAILURE="people/REACTIVATE_USER_FAILURE";
export const DEACTIVATE_USER_SUCCESS="people/DEACTIVATE_USER_SUCCESS";
export const DEACTIVATE_USER_FAILURE="people/DEACTIVATE_USER_FAILURE";
export const ROLE_CHANGE_SUCCESS="people/ROLE_CHANGE_SUCCESS";
export const ROLE_CHANGE_FAILURE="people/ROLE_CHANGE_FAILURE";
export const REPORT_SUCCESS="people/REPORT_SUCCESS";
export const REPORT_FAILURE="people/REPORT_FAILURE";